import { render } from "./fileDropperWithPreview.vue?vue&type=template&id=6ef377c4&scoped=true&ts=true"
import script from "./fileDropperWithPreview.vue?vue&type=script&lang=ts"
export * from "./fileDropperWithPreview.vue?vue&type=script&lang=ts"

import "./fileDropperWithPreview.vue?vue&type=style&index=0&id=6ef377c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef377c4"]])

export default __exports__